module.exports = __webpack_public_path__ + "img/amex.81c482a1.svg";